import * as React from "react";
import {useCart} from "@montana/containers/cart";
import {formatString} from "@montana/helpers/string-format/string-format.helper";
import {Translate} from "@montana/shared/translate";
import {Price} from "@montana/shared/price";

export interface ISummary {
    className?: string;
    header?: string;
}

export const Summary: React.FC<ISummary> = ({className, header}: ISummary): JSX.Element => {
    const {
        totalPrice,
        totalPriceWithoutVat,
        totalVatAmount,
        dispatchTime
    } = useCart();

    return (
        <div className={`summary ${className} display-body`}>
            {header &&
                <h3 className="summary__header display-6">
                    {header}
                </h3>
            }
            <div className="summary__row">
                <p><Translate value={(t): string => t.checkoutPage.priceWithoutVAT} defaultValue="Amount"/></p>
                <p className="summary__text-right"><Price obj={totalPriceWithoutVat}/></p>
            </div>
            <div className="summary__row">
                <p><Translate value={(t): string => t.checkoutPage.vat} defaultValue="VAT"/></p>
                <p className="summary__text-right"><Price obj={totalVatAmount}/></p>
            </div>

            {dispatchTime &&
                <div className="summary__dispatch-time">
                    <h3 className="summary__dispatch-header display-6">
                        <Translate value={(t): string => t.general.dispatchTime}
                                   defaultValue="Dispatch time: {0}">{(t): string => formatString(t, `${dispatchTime}`)}</Translate>
                    </h3>
                </div>
            }

            {totalPrice != null &&
                <>
                    <hr className="summary__hr border--extra-light"/>
                    <div className="summary__total-row">
                        <p className="summary__total-label display-5">
                            <Translate value="checkoutPage.totalBasketPrice"/>
                        </p>
                        <p className="summary__total-price display-5"><Price obj={totalPrice}/>
                        </p>
                    </div>
                    <div className="summary__retail-row">
                        <p className="summary__retail-text">
                            <Translate value="general.suggestedRetailPrice" defaultValue="*Suggested retail price"/>
                        </p>
                    </div>
                </>
            }

        </div>
    );
};
